'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _immutabilityHelper = require('immutability-helper');

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _antd = require('@adparlor-devops/antd');

var _reactIntl = require('react-intl');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _megaBlocs = require('@adparlor-devops/mega-blocs');

require('./Anchorman.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Anchorman = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Anchorman, _Component);

  function Anchorman() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Anchorman);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Anchorman.__proto__ || (0, _getPrototypeOf2.default)(Anchorman)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isModalVisible: false,
      isErrorModalVisible: false,
      newReportName: '',
      newReportId: null
    }, _this.componentWillReceiveProps = function (nextProps) {
      if (nextProps.createReportFailMessage === null) {
        _this.setState({
          isModalVisible: false,
          newReportName: '',
          newReportId: null
        });
      }
    }, _this.isReportCreatedByCurrentUser = function (reportId) {
      var _this2 = _this,
          props = _this2.props;

      var report = props.savedReports.data.find(function (report) {
        return report.id === reportId;
      });
      return report.created_by === props.userId;
    }, _this.onFavRestriction = function (reportId, favId) {
      if (favId) _this.props.savedReportActions.onFav(reportId, favId); // Un-favoriting
      else if (_this.isReportCreatedByCurrentUser(reportId)) _this.props.savedReportActions.onFav(reportId, favId); // Favoriting
        else {
            // User does not own the report and need to create a new report
            var newReportName = _this.props.savedReports.data.find(function (report) {
              return report.id === reportId;
            }).key + '(1)';
            _this.setState({
              isModalVisible: true,
              newReportName: newReportName,
              newReportId: reportId
            });
          }
    }, _this.onDeleteRestriction = function (reportId) {
      if (_this.isReportCreatedByCurrentUser(reportId)) {
        _this.props.savedReportActions.onDelete(reportId);
      } else {
        _this.setState({
          isErrorModalVisible: true
        });
        _antd.Modal.error({
          title: 'Error Deleting Report',
          content: _react2.default.createElement(
            'span',
            null,
            'Since you are not the owner of ',
            _react2.default.createElement(
              'strong',
              null,
              _this.props.savedReports.data.find(function (report) {
                return report.id === reportId;
              }).key
            ),
            ', you cannot delete it.'
          ),
          zIndex: 2000,
          onOk: function onOk(closeModal) {
            _this.setState({ isErrorModalVisible: false });closeModal();
          }
        });
      }
    }, _this.onModalOk = function () {
      var _this$state = _this.state,
          newReportId = _this$state.newReportId,
          newReportName = _this$state.newReportName;

      _this.props.savedReportActions.onDuplicate(newReportId, { key: newReportName });
    }, _this.onModalCancel = function () {
      _this.props.removeGlobalReportFailMessage();
      _this.setState({
        isModalVisible: false,
        newReportName: '',
        newReportId: null
      });
    }, _this.determinePopupContainerLocation = function (triggerNode) {
      if (_this.props.isPackage) return $(triggerNode).closest('.ReportManagement__Component')[0];
      return document.getElementsByClassName('ReportManagement__Component')[0];
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Anchorman, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          newReportName = _state.newReportName,
          isModalVisible = _state.isModalVisible,
          isErrorModalVisible = _state.isErrorModalVisible;
      var _props = this.props,
          platform = _props.platform,
          createReportFailMessage = _props.createReportFailMessage,
          savedReports = _props.savedReports,
          savedReportActions = _props.savedReportActions;

      var modifiedSavedReports = (0, _immutabilityHelper2.default)(savedReports, {
        actions: (0, _extends3.default)({ $merge: savedReportActions }, {
          onFav: { $set: this.onFavRestriction },
          onDelete: { $set: this.onDeleteRestriction }
        })
      });

      return _react2.default.createElement(
        'div',
        { className: 'Anchorman__Component' },
        _react2.default.createElement(
          _antd.Modal,
          {
            title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Anchorman.modal.title.label', defaultMessage: 'Create your own copy of this report (so you can edit it later).' }),
            visible: isModalVisible,
            okText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Anchorman.modal.create.button.label', defaultMessage: 'Create' }),
            onOk: function onOk() {
              return _this3.onModalOk();
            },
            onCancel: function onCancel() {
              return _this3.onModalCancel();
            },
            zIndex: 2000
          },
          createReportFailMessage && _react2.default.createElement(
            'span',
            { className: 'anchorman-create-report-fail-message' },
            createReportFailMessage
          ),
          _react2.default.createElement(_antd.Input, { value: newReportName, onChange: function onChange(event) {
              return _this3.setState({ newReportName: event.target.value });
            } })
        ),
        _react2.default.createElement(_megaBlocs.ReportManagement, {
          platform: platform,
          savedReports: modifiedSavedReports,
          isModalVisible: isModalVisible || isErrorModalVisible,
          determinePopupContainerLocation: this.determinePopupContainerLocation
        })
      );
    }
  }]);
  return Anchorman;
}(_react.Component), _class.propTypes = {
  platform: _propTypes2.default.string.isRequired,
  createReportFailMessage: _propTypes2.default.string,
  removeGlobalReportFailMessage: _propTypes2.default.func.isRequired,
  savedReportActions: _propTypes2.default.shape({
    onFav: _propTypes2.default.func.isRequired,
    onSelect: _propTypes2.default.func.isRequired,
    onDelete: _propTypes2.default.func.isRequired,
    onDuplicate: _propTypes2.default.func.isRequired
  }).isRequired,
  savedReports: _propTypes2.default.shape({
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      id: _propTypes2.default.number.isRequired,
      advertiser_id: _propTypes2.default.number.isRequired,
      group: _propTypes2.default.string.isRequired,
      key: _propTypes2.default.string.isRequired,
      value: _propTypes2.default.string.isRequired
    }))
  }).isRequired,
  isPackage: _propTypes2.default.bool
}, _class.defaultProps = {
  createReportFailMessage: null,
  isPackage: true
}, _temp2);
exports.default = Anchorman;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/anchorman/lib/modules/Anchorman/components/Anchorman.js
// module id = 2705
// module chunks = 1